import type { ReactNode } from 'react';
import styled from 'styled-components';
import { space as styledSpace, SpaceProps } from 'styled-system';

interface MenuContainerStyledProps extends SpaceProps {
  $width: number;
  $collapseWidth: number;
  $collapsed: boolean;
  $fluid: boolean;
}

export const MenuContainer = styled.div<MenuContainerStyledProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  width: ${({ $fluid, $width, $collapsed, $collapseWidth }) =>
    $fluid ? '100%' : `${$collapsed ? $collapseWidth : $width}px`};
  flex: 1 0 0;
  min-height: 0;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: width 200ms ease-in-out;

  *::-webkit-scrollbar-track {
    background: inherit;
  }

  ${styledSpace}
`;

const MenuWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

export interface MenuContainerProps extends SpaceProps {
  width?: number;
  collapsed?: boolean;
  collapseWidth?: number;
  fluid?: boolean;
  footer?: ReactNode;
  children: ReactNode;
}

export function MenuContainerComponent({
  width = 244,
  collapsed = false,
  collapseWidth = 50,
  fluid = false,
  footer,
  children,
  ...spaceProps
}: MenuContainerProps) {
  return (
    <MenuContainer
      $width={width}
      $collapseWidth={collapseWidth}
      $collapsed={collapsed}
      $fluid={fluid}
      {...spaceProps}
    >
      <MenuWrapper>{children}</MenuWrapper>
      {footer}
    </MenuContainer>
  );
}
